import { PulseLoader } from "react-spinners";

const FallbackLoading = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-canvas/80">
      <PulseLoader color="#181d26" />
    </div>
  );
};

export default FallbackLoading;
